<section id="add-containers-dlg" class="advancedMode page-layout simple left-sidebar inner-sidebar inner-scroll">
  <div class="uds-page-title" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
    {{getTitle() | translate}}
  </div>

  <div class="content p-20 dp-white" fxLayout="column" fxLayoutAlign="start center">
    <div>
      <ng-container *ngIf="shipmentType === ShipmentType.INTERMODAL_SHIPMENT; else elseAdd">
        <div class="mt-40 add-text grey-color">
          {{ 'add_shipments.how_you_want_to_add_shipments_txt' | translate }}
        </div>
        <p class="add-text mt-8">
          <b>{{ 'add_shipments.do_you_know_txt' | translate }}?</b>&nbsp;<span>{{ 'add_shipments.add_carrier_increases_tracking_txt' | translate }}</span>
        </p>
      </ng-container>
      <ng-template #elseAdd>
        <div class="heading-sub-regular mt-40 mb-40">
          {{ 'add_shipments.how_you_want_to_add_shipments_txt' | translate }}
        </div>
      </ng-template>
      <div class="mt-40 mb-40">
        <button mat-flat-button class="easy-button mr-60" (click)="logEvent('ADD SHIPMENT ONE BY ONE');gotoAddShipmentOneByOne()" *ngIf="!isRoadShipment()">{{ 'add_shipments.add_shipment_one_by_one_txt' | translate }}</button>
        <button mat-flat-button class="easy-button mr-60" *ngIf="isRoadShipment()" (click)="logEvent('ADD SINGLE SHIPMENT');gotoAddShipmentOneByOne()">{{ 'add_shipments.add_single_shipment' | translate }}</button>
        <button mat-flat-button class="easy-button mr-60" (click)="logEvent('UPLOAD SHIPMENTS IN BULK');globalFileInput.click()">{{ 'add_shipments.upload_shipments_in_bulk_txt' | translate }}</button>

        <ng-container *ngIf="shipmentType === ShipmentType.INTERMODAL_SHIPMENT">
          <button mat-flat-button class="easy-button mr-60"
            (click)="logEvent('UPDATE EXISTING SHIPMENTS');bulkUpdateFileInput.click()">{{ 'add_shipments.update_existing_shipments' | translate }}</button>
        </ng-container>

        <ng-container *ngIf="shipmentType === ShipmentType.TRUCK_SHIPMENT">
          <button mat-flat-button class="easy-button mr-60"
            (click)="logEvent('UPDATE EXISTING SHIPMENTS');globalFileInputForRoad.click()">{{ 'add_shipments.update_existing_shipments' | translate }}</button>
        </ng-container>

        <ng-container
          *ngIf="shipmentType === ShipmentType.INTERMODAL_SHIPMENT || shipmentType === ShipmentType.TRUCK_SHIPMENT || shipmentType === ShipmentType.AIR_SHIPMENT">
          <button mat-flat-button class="easy-button" (click)="logEvent('UPLOAD MILESTONES IN BULK');milestonesFileInput.click()">{{ 'add_shipments.add_update_milestone_txt' | translate }}</button>
        </ng-container>
      </div>

      <input #globalFileInputForRoad type="file" accept=".csv,.xlsx" id="globalFileSelect"
        (change)="handleFileInput($event.target.files, 'ROAD_BULK_UPDATE')" style="display: none;" />

      <input #globalFileInput type="file" accept=".csv,.xlsx" id="globalFileSelect" (change)="handleFileInput($event.target.files)"
        style="display: none;" />

      <input #bulkUpdateFileInput type="file" accept=".csv,.xlsx" id="globalFileSelect"
        (change)="handleBulkUpdateFileInput($event.target.files)" style="display: none;" />
      <input #milestonesFileInput type="file" accept=".csv,.xlsx" id="milestonesFileSelect"
        (change)="handleMilestonesFileInput($event.target.files)" (click)="$event.target.value = ''" style="display: none;" />
    </div>
  </div>

</section>